<template>
  <transition>
    <div>
      <div v-if="mode === 'animate'" class="preloader" :class="{ 'search-loader' : searchTerm && !isSmall, 'small' : isSmall, 'fit-height' : fitHeight, 'background' : background}">
        <div v-if="$isIsef" class="lds-spinner" aria-label="Loader Spinner"><div></div><div aria-hidden="true"></div><div aria-hidden="true"></div><div aria-hidden="true"></div><div aria-hidden="true"></div><div aria-hidden="true"></div><div aria-hidden="true"></div><div aria-hidden="true"></div><div aria-hidden="true"></div><div aria-hidden="true"></div><div aria-hidden="true"></div><div aria-hidden="true"></div></div>
        <div v-else class="loader-logo" qa="loading-logo">
          <img :src="logo" :alt="logoAlt">
        </div>
        <div class="has-text-weight-semibold attachment-text" :class="{'light-text': lightTextColor}" v-html="loadingText"></div>
      </div>
      <div v-if="mode === 'static'">
        <div qa="loading-logo">
          <img :src="logo" :alt="logoAlt">
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import i18n from '@/i18n'

export default {
  props: ['attachmentsLoaded', 'attachmentsLength', 'searchTerm', 'isSmall', 'displayText', 'lightTextColor', 'fitHeight', 'mode', 'background'],
  computed: {
    appName: function () {
      return process.env.APP_NAME.toLowerCase()
    },
    logo: function () {
      switch (this.appName) {
        case 'neweng':
          return '/static/logo-eng.svg'
        case 'ajas':
          return '/static/ajas/ajas-logo.png'
        case 'isef':
          return '/static/isef/logo/isef-logo.png'
        case 'projectboard':
          return '/static/projectboard/logo/logo-pb.png'
        case 'societyforsciencebcm':
          return '/static/societyforsciencebcm/logo/loader.png'
        case 'girls-and-steam':
          return '/static/girls-and-steam/loader.png'
        case 'ysc':
          return '/static/ysc/logo-ysc.png'
        case 'ohiosci':
          return '/static/ohiosci/logo/chatlogo.png'
        case 'cnmiiwsf':
          return '/static/cnmi/cnmi-loader.png'
        case 'buckeye':
          return '/static/buckeye/buckeye-loader-v2.png'
        case 'sts':
          return '/static/sts/mainlogo.png'
        case 'oasam':
          return '/static/oasam/oasam-loader.png'
        case 'sigmaxi':
          return '/static/sigmaxi/sigmaxi-loader.png'
        default:
          return '/static/makey-logo.png'
      }
    },
    logoAlt: function () {
      switch (this.appName) {
        case 'neweng':
          return 'Bouncing engineering.com logo'
        case 'ajas':
          return 'Bouncing American Junior Academy of Science logo'
        case 'ohiosci':
          return 'Bouncing Ohio Science logo'
        case 'cnmiiwsf':
          return 'Bouncing CNMI logo'
        case 'buckeye':
          return 'Bouncing Buckeye logo'
        case 'sts':
          return 'Bouncing Sts logo'
        case 'oasam':
          return 'Bouncing Ohio Science Annual Meeting logo'
        case 'sigmaxi':
          return 'Bouncing Sigmaxi logo'
        default:
          return 'Bouncing makeprojects.com logo'
      }
    },
    loadingText: function () {
      if (this.searchTerm) {
        return i18n.t('search.searchingFor') + ' ' + this.searchTerm + '</b>...'
      } else if (this.displayText) {
        return this.displayText
      } else if (this.attachmentsLength) {
        return `${i18n.t('projectPage.savingAttachment')} ${this.attachmentsLoaded + 1} ${i18n.t('projectPage.of')} ${this.attachmentsLength}`
      } else {
        return ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~styles/utils.scss";

.search-loader {
  max-width: 736px;
  padding-top: 100px;
  position: relative !important;
}
.preloader{
  display:flex;
  flex-direction: column;
  align-items:center;
  justify-content: center;
  position: absolute;
  overflow: hidden;
  text-align: center;
  width: 100%;
  height: 100%;
  background-color: none;
  z-index: 15;
  .attachment-text{
    margin-top: 0.5rem;
    color: black;
    font-size: 1.5rem;
    @include mobile {
      margin: 0.5rem 2rem;
      font-size: 1.25rem;
    }
  }
  .light-text {
    color: white;
  }
  .small {
    @include fullhd {
      height: calc(100% - (52px + 251px)); // navbar-height (52px) + search-header-height-fullhd (251px)
    }
    @include touch {
      height: calc(100% - (52px + 241px)); // navbar-height (52px) + search-header-height-touch-and-mobile (241px)
    }
    height: calc(100% - (52px + 235px)); // navbar-height (52px) + search-header-height-desktop (258px)
    overflow-y: hidden;
  }
  &.fit-height {
    height: calc(100vh - 40px - 152px - 52px - 40px);
    left: 0
  }
}
.background {
  background-color: rgba($color: white, $alpha: 1);
}
.loader-logo{
  width: 25%;
  max-width: 8rem;
  animation: bounce 1s cubic-bezier(.7,0,1,1) infinite alternate;
}
@keyframes bounce {
  0% {
    transform: translateY(-50px) scaleX(1) scaleY(1);
  }
  90% {
    transform: translateY(-12px) scaleX(1) scaleY(1);
  }
  100% {
    transform: translateY(0) scaleX(1.1) scaleY(0.9);
  }
}

.lds-spinner {
  color: official;
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-spinner div {
  transform-origin: 40px 40px;
  animation: lds-spinner 1.2s linear infinite;
}
.lds-spinner div:after {
  content: " ";
  display: block;
  position: absolute;
  top: 3px;
  left: 37px;
  width: 6px;
  height: 18px;
  border-radius: 20%;
  background: #ED761E;
}
.lds-spinner div:nth-child(1) {
  transform: rotate(0deg);
  animation-delay: -1.1s;
}
.lds-spinner div:nth-child(2) {
  transform: rotate(30deg);
  animation-delay: -1s;
}
.lds-spinner div:nth-child(3) {
  transform: rotate(60deg);
  animation-delay: -0.9s;
}
.lds-spinner div:nth-child(4) {
  transform: rotate(90deg);
  animation-delay: -0.8s;
}
.lds-spinner div:nth-child(5) {
  transform: rotate(120deg);
  animation-delay: -0.7s;
}
.lds-spinner div:nth-child(6) {
  transform: rotate(150deg);
  animation-delay: -0.6s;
}
.lds-spinner div:nth-child(7) {
  transform: rotate(180deg);
  animation-delay: -0.5s;
}
.lds-spinner div:nth-child(8) {
  transform: rotate(210deg);
  animation-delay: -0.4s;
}
.lds-spinner div:nth-child(9) {
  transform: rotate(240deg);
  animation-delay: -0.3s;
}
.lds-spinner div:nth-child(10) {
  transform: rotate(270deg);
  animation-delay: -0.2s;
}
.lds-spinner div:nth-child(11) {
  transform: rotate(300deg);
  animation-delay: -0.1s;
}
.lds-spinner div:nth-child(12) {
  transform: rotate(330deg);
  animation-delay: 0s;
}
@keyframes lds-spinner {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>
